import { Button, FormControl, FormHelperText, Grid, Typography } from '@mui/material'
import React from 'react'
import CustomAutocompleteComp from '../../../../newComponent/AutocompleteComp'
import { useState } from 'react';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useGetTokenOrLogout } from '../../../../../utils/token';
import CustomSnackbar from '../../../../components/ui-component/snackbar/CustomSnackbar';
import CustomTextFieldComp from '../../../../newComponent/customTextFieldComp';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function EditTrainerExpertise({ onClose, selectedData }) {
  console.log("selectedData",selectedData)
    const userId = localStorage.getItem("userId");
      const getTokenOrLogout = useGetTokenOrLogout();
  const [testTypeList, setTestTypeList] = useState([]);
  const [selectedTestType, setSelectedTestType] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState("");
    const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  // ✅ Match names in selectedData to testTypeList after fetching
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}testtype`); 
        if (response.ok) {
          const data = await response.json();
          setTestTypeList(data);

          if (selectedData?.trainer_expertise?.length) {
                const selectedExpertiseUpper = selectedData.trainer_expertise.map((name) =>
                    name.toUpperCase()
                );

                const matched = data.filter((item) =>
                    selectedExpertiseUpper.includes(item.name.toUpperCase())
                );

                setSelectedTestType(matched);
                setValue(
                    "trainer_expertise",
                    matched.map((m) => m.id)
                );
                }

        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedData, setValue]);

  const handleExpertiseChange = (event, value) => {
    setSelectedTestType(value);
    const selectedIds = value.map((i) => i.id);
    setValue("trainer_expertise", selectedIds);
  };

  const onSubmit = async (data) => {
    if (selectedTestType.length === 0) {
      showSnackbar("Select at least one expertise", "error");
      return;
    }
    const requestData = {
      ...data,
      user_id: parseInt(userId),
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}trainer/${selectedData?.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
        },
          body: JSON.stringify(requestData),
        }
      );
     
      if (response.status == 200) {
        showSnackbar("Data updated successfully", "success");
        setTimeout(() => {
          window.location.reload();
           onClose();
        }, 1500);
      } else if (response.status === 400) {
        showSnackbar("Error updating trainer expertise", "error");
      } else {
        showSnackbar("Internal Server Error :", "error");
      }
    } catch (error) {
      showSnackbar("Internal Server Error :", "error");
    }
  };

  return (
    <>
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth error={!!errors.trainer_expertise}>
            <Typography variant="h6">
              Select Trainer Expertise{" "}
              <span style={{ color: "red", marginLeft: "4px", fontSize: "0.7em" }}>
                *
              </span>
            </Typography>
            <Controller
              name="trainer_expertise"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <CustomAutocompleteComp
                  {...field}
                  size="small"
                  multiple
                  disablePortal
                  value={selectedTestType}
                  onChange={handleExpertiseChange}
                  options={testTypeList}
                  getOptionLabel={(option) => option.name}
                  tooltipContent={(option) => option.name}
                />
              )}
            />
            {errors.trainer_expertise && (
              <FormHelperText>
                Select at least one expertise
              </FormHelperText>
            )}
          </FormControl>

       
        </Grid>

            <Grid item xs={12} >
                       
                          <Typography variant="h6">
                            Work Experience(Year){" "}
                            <span
                              style={{
                                color: "red",
                                position: "absolute",
                                marginLeft: "4px",
                                fontSize: "0.7em",
                              }}
                            >
                              *
                            </span>
                          </Typography>
          
                          <Controller
                            name="work_experience"
                            control={control}
                           rules={{ required: true }}
                           defaultValue={selectedData?.work_experience}
                            render={({ field }) => (
                              <CustomTextFieldComp
                                size="normal"
                                type="number"
                                {...field}
                                InputProps={{
                                  style: { borderRadius: "10px", height: "37px" },
                                }}
                                fullWidth
                                error={errors.work_experience}
                                helperText={
                                  errors.work_experience && "Work experience is required"
                                }
                              />
                            )}
                          />
                
                      </Grid>

        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button variant="contained" color="primary" type="submit">
            Save
          </Button>
        </Grid>
      </Grid>
    </form>
    <CustomSnackbar
            open={snackbarOpen}
            onClose={() => setSnackbarOpen(false)}
            message={snackbarMessage}
            severity={snackbarSeverity}
          />
    </>
  );
}

export default EditTrainerExpertise;
